import { Tent, MapPin, AlertTriangle, CheckCircle, X, Moon, Flame, Trash2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import './WildcampingRulesPage.css';

export default function WildcampingRulesPage() {
  return (
    <div className="wildcamping-page">
      <div className="wildcamping-header">
        <h1>🏕️ Wildcamping in Schottland</h1>
        <p>Scottish Outdoor Access Code - Dein Recht & deine Pflicht</p>
      </div>

      <div className="wildcamping-content">
        <section className="rules-hero">
          <div className="hero-card">
            <CheckCircle size={48} color="#10b981" />
            <div>
              <h2>✅ Wildcamping ist ERLAUBT!</h2>
              <p>Schottland hat eines der liberalsten Wildcamping-Gesetze Europas dank des <strong>Scottish Outdoor Access Code</strong></p>
            </div>
          </div>
        </section>

        <section className="rules-section">
          <h2><Tent size={24} /> Die Grundregeln</h2>
          <div className="rules-grid">
            <div className="rule-card green">
              <CheckCircle size={32} />
              <h3>Erlaubt</h3>
              <ul>
                <li>✓ Wildcamping auf unkultiviertem Land</li>
                <li>✓ 2-3 Nächte am gleichen Ort</li>
                <li>✓ Kleine Gruppen (max 2-3 Zelte)</li>
                <li>✓ Distanz zu Wohnhäusern (min 100m)</li>
                <li>✓ Außerhalb von Nationalparks meist überall</li>
              </ul>
            </div>

            <div className="rule-card red">
              <X size={32} />
              <h3>NICHT Erlaubt</h3>
              <ul>
                <li>✗ Loch Lomond & Trossachs (März-Sept ohne Permit)</li>
                <li>✗ Auf Privatgrundstücken ohne Erlaubnis</li>
                <li>✗ Auf bewirtschafteten Feldern</li>
                <li>✗ In der Nähe von Gebäuden</li>
                <li>✗ Gruppen > 3 Zelte ohne Genehmigung</li>
                <li>✗ Motorisierte Fahrzeuge im Gelände</li>
              </ul>
            </div>
          </div>
        </section>

        <section className="rules-section special">
          <h2><AlertTriangle size={24} /> Loch Lomond Ausnahme</h2>
          <div className="special-warning">
            <AlertTriangle size={40} color="#f59e0b" />
            <div>
              <h3>Camping Management Zones</h3>
              <p>Im <strong>Loch Lomond & The Trossachs National Park</strong> gelten von <strong>1. März bis 30. September</strong> besondere Regeln:</p>
              <ul>
                <li>⚠️ Wildcamping nur in ausgewiesenen Bereichen</li>
                <li>⚠️ Buchung & Permit erforderlich</li>
                <li>💷 Gebühr: ca. £3-8 pro Nacht</li>
                <li>🌐 Buchung: <a href="https://www.lochlomond-trossachs.org" target="_blank" rel="noopener noreferrer">lochlomond-trossachs.org</a></li>
              </ul>
            </div>
          </div>
        </section>

        <section className="rules-section">
          <h2><Flame size={24} /> Leave No Trace Prinzipien</h2>
          <div className="principles-grid">
            <div className="principle">
              <div className="principle-icon">🔥</div>
              <h4>Feuer</h4>
              <p>Nur Campingkocher! Offene Feuer sind gefährlich und meist verboten.</p>
            </div>
            <div className="principle">
              <div className="principle-icon">🚽</div>
              <h4>Toilette</h4>
              <p>Mind. 30m von Gewässern entfernt. Grabe ein 15cm tiefes Loch und vergrabe alles.</p>
            </div>
            <div className="principle">
              <div className="principle-icon">🗑️</div>
              <h4>Müll</h4>
              <p>Nimm ALLES mit! Auch organische Abfälle (Bananenschalen, etc.)</p>
            </div>
            <div className="principle">
              <div className="principle-icon">🧼</div>
              <h4>Waschen</h4>
              <p>Keine Seife in Seen/Flüssen. Mind. 50m Abstand zum Gewässer.</p>
            </div>
            <div className="principle">
              <div className="principle-icon">🌿</div>
              <h4>Natur</h4>
              <p>Keine Pflanzen beschädigen. Auf vorhandenen Pfaden bleiben.</p>
            </div>
            <div className="principle">
              <div className="principle-icon">🐑</div>
              <h4>Tiere</h4>
              <p>Viehtore schließen! Hunde an der Leine (Lämmer-Saison März-Mai).</p>
            </div>
          </div>
        </section>

        <section className="rules-section">
          <h2><Moon size={24} /> Beste Wildcamping-Spots</h2>
          <div className="spots-list">
            <div className="spot">
              <MapPin size={20} color="#10b981" />
              <div>
                <strong>Glen Affric</strong>
                <p>Highlands - Einsame Täler, spektakuläre Berge</p>
              </div>
            </div>
            <div className="spot">
              <MapPin size={20} color="#10b981" />
              <div>
                <strong>Isle of Skye</strong>
                <p>Dramatische Landschaften (außerhalb der Hotspots)</p>
              </div>
            </div>
            <div className="spot">
              <MapPin size={20} color="#10b981" />
              <div>
                <strong>Cairngorms</strong>
                <p>Weite Plateaus, einsame Glens</p>
              </div>
            </div>
            <div className="spot">
              <MapPin size={20} color="#10b981" />
              <div>
                <strong>Galloway Forest</strong>
                <p>Dark Sky Park - perfekt für Sternenhimmel</p>
              </div>
            </div>
          </div>
        </section>

        <section className="rules-section checklist">
          <h2>✅ Wildcamping Packliste</h2>
          <div className="checklist-grid">
            <div className="checklist-item">✓ Leichtes Zelt (wind- & wasserdicht)</div>
            <div className="checklist-item">✓ Warmer Schlafsack (-5°C min)</div>
            <div className="checklist-item">✓ Isomatte (gegen Bodenkälte)</div>
            <div className="checklist-item">✓ Campingkocher + Gas</div>
            <div className="checklist-item">✓ Müllbeutel (alles mitnehmen!)</div>
            <div className="checklist-item">✓ Klopapier + Schaufel</div>
            <div className="checklist-item">✓ Wasserfilter/Tabletten</div>
            <div className="checklist-item">✓ Stirnlampe</div>
            <div className="checklist-item">✓ Wetterfeste Kleidung</div>
            <div className="checklist-item">✓ Erste-Hilfe Set</div>
          </div>
        </section>

        <section className="rules-section warning">
          <h2><AlertTriangle size={24} /> Wichtige Warnungen</h2>
          <ul className="warning-list">
            <li>⚠️ <strong>Wetter:</strong> Kann sich schnell ändern! Immer Regenkleidung dabei.</li>
            <li>⚠️ <strong>Midges:</strong> Mai-September - Insektenschutz essentiell!</li>
            <li>⚠️ <strong>Lämmer-Saison:</strong> März-Mai - Hunde an die Leine!</li>
            <li>⚠️ <strong>Bothy-Etikette:</strong> Bothies sind offen für alle - sauber hinterlassen!</li>
            <li>⚠️ <strong>Notfall:</strong> 112/999 - GPS-Koordinaten bereithalten</li>
          </ul>
        </section>

        <div className="rules-footer">
          <div className="footer-links">
            <a href="https://www.outdooraccess-scotland.scot" target="_blank" rel="noopener noreferrer" className="btn-external">
              📖 Scottish Outdoor Access Code
            </a>
            <Link to="/first-aid" className="btn-external">
              🏥 Erste-Hilfe Guide
            </Link>
          </div>
          <Link to="/" className="btn-back">
            ← Zurück zur Startseite
          </Link>
        </div>
      </div>
    </div>
  );
}
